export const LANG_STORAGE_KEY = 'dronekz_lang';
export const LANG_SOURCE_STORAGE_KEY = 'dronekz_language_source';
export const LANG_AUTO_STORAGE_KEY = 'dronekz_auto_language';
export const LANG_SOURCE_MANUAL = 'manual';
export const LANG_SOURCE_AUTO = 'auto';
export const DEFAULT_LANG = 'nameEn';
export const SUPPORTED_LANGS = ['nameRu', 'nameKz', 'nameEn'];

export const isSupportedLang = (lang) => SUPPORTED_LANGS.includes(lang);

const readStorage = (key) => {
    try {
        return localStorage.getItem(key);
    } catch (_) {
        return null;
    }
};

const writeStorage = (key, value) => {
    try {
        localStorage.setItem(key, value);
        return true;
    } catch (_) {
        return false;
    }
};

export const persistLangPreference = (lang, source) => {
    if (!isSupportedLang(lang)) return false;
    writeStorage(LANG_STORAGE_KEY, lang);
    writeStorage(LANG_SOURCE_STORAGE_KEY, source);
    if (source === LANG_SOURCE_AUTO) {
        writeStorage(LANG_AUTO_STORAGE_KEY, lang);
    }
    return true;
};

export const detectBrowserLang = (languages) => {
    const list = Array.isArray(languages) ? languages : [];
    for (const raw of list) {
        if (!raw || typeof raw !== 'string') continue;
        const base = raw.trim().toLowerCase().replace(/_/g, '-').split('-')[0];
        if (!base) continue;
        if (base === 'kk') return 'nameKz';
        if (base === 'ru') return 'nameRu';
        return 'nameEn';
    }
    return DEFAULT_LANG;
};

const collectBrowserLanguages = () => {
    try {
        if (typeof navigator === 'undefined') return [];
        const list = [];
        if (Array.isArray(navigator.languages)) list.push(...navigator.languages);
        if (navigator.language) list.push(navigator.language);
        return list;
    } catch (_) {
        return [];
    }
};

export const resolveInitialLang = (browserLanguages) => {
    const saved = readStorage(LANG_STORAGE_KEY);
    const source = readStorage(LANG_SOURCE_STORAGE_KEY);

    if (isSupportedLang(saved) && source === LANG_SOURCE_MANUAL) {
        return saved;
    }

    // Legacy dronekz_lang without source = previous switcher choice → treat as manual.
    if (isSupportedLang(saved) && source !== LANG_SOURCE_AUTO) {
        writeStorage(LANG_SOURCE_STORAGE_KEY, LANG_SOURCE_MANUAL);
        return saved;
    }

    if (isSupportedLang(saved) && source === LANG_SOURCE_AUTO) {
        return saved;
    }

    const detected = detectBrowserLang(
        browserLanguages == null ? collectBrowserLanguages() : browserLanguages
    );
    persistLangPreference(detected, LANG_SOURCE_AUTO);
    return detected;
};

export const getStoredLang = () => {
    const saved = readStorage(LANG_STORAGE_KEY);
    if (isSupportedLang(saved)) return saved;
    return resolveInitialLang();
};

export const localeField = (lang) => {
    if (lang === 'nameKz' || lang === 'kz') return 'name_kz';
    if (lang === 'nameEn' || lang === 'en') return 'name_en';
    return 'name_ru';
};

export const localizedName = (row, lang, fallback = '—') => {
    if (!row || typeof row !== 'object') return fallback;
    const field = localeField(lang);
    return row[field] || row.name_en || row.name_ru || row.name_kz || row.value || fallback;
};

export const localizedLabel = (obj, lang, fallback = '') => {
    if (!obj || typeof obj !== 'object') return fallback;
    if (lang === 'nameKz' || lang === 'kz') return obj.nameKz || obj.nameRu || obj.nameEn || fallback;
    if (lang === 'nameEn' || lang === 'en') return obj.nameEn || obj.nameRu || obj.nameKz || fallback;
    return obj.nameRu || obj.nameEn || obj.nameKz || fallback;
};

export const localizedDistrictLabel = (row, lang) => {
    const name = localizedName(row, lang, '');
    if (!name) return '—';
    const stripped = name.replace(/\s+(район|ауданы|district)$/i, '').trim();
    return stripped || name;
};

export const htmlLang = (lang) => {
    if (lang === 'nameKz') return 'kk';
    if (lang === 'nameEn') return 'en';
    return 'ru';
};

export const dayjsLocaleCode = (lang) => {
    if (lang === 'nameKz') return 'kk';
    if (lang === 'nameEn') return 'en';
    return 'ru';
};

export const intlLocale = (lang) => {
    if (lang === 'nameKz') return 'kk-KZ';
    if (lang === 'nameEn') return 'en-US';
    return 'ru-RU';
};
